import CheckIcon from '@mui/icons-material/Check'
import { styled } from '@mui/material'

export const Root = styled('div', {
  shouldForwardProp: (prop) => prop !== 'ownerState',
})<{ ownerState: { active: boolean } }>(({ theme, ownerState }) => ({
  fontSize: '0.75rem',
  fontWeight: 'bold',
  fontFamily: '"Helvetica Neue", "Arial", sans-serif',
  backgroundColor: ownerState.active ? '#EF2828' : '#F5F5F5',
  boxShadow: ownerState.active ? '0 0 0 0' : undefined,
  color: ownerState.active ? '#fff' : '#999999',
  zIndex: 1,
  width: 24,
  height: 24,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  border: 'none',

  '& > div': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  [theme.breakpoints.up('sm')]: {
    width: 20,
    height: 20,
  },
}))

export const CompletedIcon = styled(CheckIcon)(({ theme }) => ({
  backgroundColor: '#EF2828',
  color: 'white',
  width: theme.spacing(3),
  height: theme.spacing(3),
  display: 'flex',
  borderRadius: '50%',
  border: '1px solid rgba(0, 0, 0, 0.08)',

  [theme.breakpoints.up('sm')]: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
  },
}))
